import { Action, ActionType } from "@redux/actionTypes/commercialActionType";
import { Reducer } from "redux";

export interface IcommercialListState {
  commercialsDetailsByPID: ProjectCommercialsForm[];
}

export interface ProjectCommercialsForm {
  projectId: number;
  projectName: string;
  vendorName: string;
  initiatingBusinessUnitId: string;
  status: string;
  estimatedOpex: number;
  commercialType: string;
  inCome: number;
  projectDetailsByBusinessUnits: projectDetails[];
}

export interface projectDetails {
  countryId: number;
  dosageForm: string;
  packStyle: string;
  strength: number;
  strengthUnit: string;
  packTradeDress: string;
  currencyId: number;
  marketDetail: {
    marketDetailId?: number;
    marketSp: number;
    marketVolume: number;
    marketValue: number;
    expectedMarketVolume: number;
    noOfCompetitor: number;
    currencyId: number;
  };
  marketShareEstimate: {
    high: number;
    mid: number;
    low: number;
    detailId?: number;
    marketShareId?: number;
    createdDate?: string;
    createdBy?: string;
  };
  discounting: {
    high: number;
    mid: number;
    low: number;
    erosion: number;
    detailId?: number;
    discountId?: number;
    createdDate?: string;
    createdBy?: string;
  };
  marketShareAssumption: {
    year1: string;
    year2: string;
    year3: string;
    year4: string;
    year5: string;
  };
  discountingAssumption: {
    year1: string;
    year2: string;
    year3: string;
    year4: string;
    year5: string;
  };

  // SimplifiedCommercial commercial details
  simplifiedMarketShareAssumption: {
    detailId?: number,
    simplifiedMarketShareId?: number,
    year1: number,
    year2: number,
    year3: number,
    year4: number,
    year5: number,

  };
  simplifiedPriceDiscount: {
    detailId?: number,
    simplifiedDiscountId?: number,
    year1: number,
    year2: number,
    year3: number,
    year4: number,
    year5: number,
    erosion: number,

  }

}

export interface PreviewDetailsList {
  _Success: any;
  previewDetailsVolumes: PreviewDetailsVolumes[];
}
export interface PreviewDetailsVolumes {
  columnValue: number;
  order: number;
  type: string;
  year1: number;
  year2: number;
  year3: number;
  year4: number;
  year5: number;
}
const initialState = {
  commercialsDetailsByPID: [],
};

export const commercialReducer: Reducer<IcommercialListState, Action> = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.COMMERCIAL_DETAIL_BY_PID:
      return {
        ...state,
        commercialsDetailsByPID: action.payload,
      };
    case ActionType.RESET_REDUX_STATE: {
      return initialState;
    }
    default:
      return state;
  }
};
